<div class="card">
     <div class="card-header d-flex justify-content-between align-items-center p-3 pb-1">
          <h6 class="card-title d-flex align-items-center">
               <span class="fs-6">{{ form.data['title'] }}</span>
               <button type="button" class="btn btn-outline-primary btn-sm ms-2" data-bs-toggle="modal"
                    [attr.data-bs-target]="'#addChildModel' + form.data['id']" (click)="resetAndGetData()">
                    <i class="fa fa-plus me-1" style="font-size: 0.8rem;"></i>
                    {{'UI_FORM.CHILD.ADD' | translate}}
               </button>
          </h6>
     </div>
     <div class="card-body" style="max-height: 250px; overflow-y: auto;">
          <div class="table-responsive">
               <table class="table table-sm table-striped my-1 w-100">
                    <thead class="table-light">
                         <tr>
                              <th class="text-nowrap">{{'UI_FORM.CHILD.TABLE.SNO' | translate}}</th>
                              <th *ngFor="let field of form.data['fields']; let i = index" class="text-nowrap">
                                   <ng-container *ngIf="getAttributeListById(field.id) as e">
                                        <span (click)="sortTable(e.code)" class="d-flex align-items-center">
                                             {{ getFilterLable(field["label"]) }}
                                             <i *ngIf="sortedField === e.code && sortOrder === 'ASC'"
                                                  class="fa fa-sort-up ms-1"></i>
                                             <i *ngIf="sortedField === e.code && sortOrder === 'DESC'"
                                                  class="fa fa-sort-down ms-1"></i>
                                             <i *ngIf="sortedField !== e.code" class="fa fa-sort ms-1"></i>
                                        </span>
                                   </ng-container>
                              </th>
                              <th class="text-nowrap">{{'UI_FORM.CHILD.TABLE.ACTION' | translate}}</th>
                         </tr>
                    </thead>
                    <tbody>
                         <tr *ngFor="let e of filteredData; let i = index">
                              <td class="align-middle">{{ pageIndex(i) }}</td>
                              <td *ngFor="let field of form.data['fields']; let i = index" class="align-middle">
                                   <ng-container *ngIf="getAttributeListById(field.id) as at">
                                        <span
                                             *ngIf="at['type'] === 'object' && at['type'] != 'file' && at['type'] != 'doc'">
                                             {{ e[at["code"]] | json }}
                                        </span> 

                                          <span *ngIf=" at['type'] === 'object' && at['type'] != 'file'  &&  at['type'] != 'doc'  && at['type'] != 'time' && at['type'] !== 'location' && at['type'] !== 'boolean'">
                                              {{ e[at["code"]] | json }}
                                        </span>

                                      <span
                                             *ngIf="at['type'] != 'object' && at['type'] != 'file'  &&  at['type'] != 'doc' && at['type'] !== 'email' && at['type'] !== 'location' && at['type'] !== 'itime' && at['type'] !== 'textarea' && at['type'] !== 'boolean' && at['type'] !== 'time' && at['type'] !== 'dateandtime'">
                                             {{at["depAttribute"]? getString(e[at["depAttribute"]], at["type"])
                                             : getString(e[at["code"]], at["type"])}}
                                      </span> 

                                      <!-- Date & Time  -->
                                     <span *ngIf="at['type'] === 'dateandtime'">
                                        {{ getString(e[at["code"]], at["type"]) }}
                                     </span>

                                      <!-- iTime Type -->
                                    <span
                                      *ngIf="at['type'] === 'itime'"
                                      class="badge bg-secondary bg-opacity-10 text-dark p-2"
                                    >
                                      <i class="bi bi-hourglass-split me-1"></i>
                                      {{
                                        at["depAttribute"]
                                          ? getStringitime(
                                              e[at["depAttribute"]],
                                              at["type"],
                                              at["itimeFormat"]
                                            )
                                          : getStringitime(
                                              e[at["code"]],
                                              at["type"],
                                              at["itimeFormat"]
                                            )
                                      }}
                                    </span>


                                      <!-- <span *ngIf="
                                        at['type'] != 'object' && at['type'] != 'file'  &&  at['type'] != 'doc' && at['type'] != 'time'  && at['type'] != 'textarea' && at['type'] != 'email' && at['type'] !== 'location' && at['type'] !== 'boolean' && at['type'] !== 'text'">
                                          {{at["depAttribute"]? getString(e[at["depAttribute"]], at["type"])
                                         : getString(e[at["code"]], at["type"])}}
                                      </span> -->

                                      <!-- File Type -->
                                    <span
                                      *ngIf="
                                        at['type'] !== 'list' &&
                                        at['type'] !== 'object' &&
                                        at['type'] === 'file' &&
                                        at['type'] !== 'doc' &&
                                        at['type'] != 'time' &&
                                        at['type'] !== 'location' &&
                                        at['type'] !== 'email' &&
                                        at['type'] !== 'boolean' &&
                                        at['type'] !== 'idate' &&
                                        at['type'] !== 'json'
                                      "
                                    >
                                      <a
                                        href="{{ getAppDoc(e[at['code']]) }}"
                                        target="_blank"
                                        class="d-inline-block"
                                      >
                                        <img
                                          src="{{
                                            getAppDocThumbnail(e[at['code']])
                                          }}"
                                          class="img-thumbnail rounded-3"
                                          width="60"
                                          alt="File preview"
                                        />
                                             </a>
                                        </span>

                                      <!-- Doc Type -->
                                    <span
                                      *ngIf="
                                        at['type'] !== 'list' &&
                                        at['type'] !== 'object' &&
                                        at['type'] !== 'file' &&
                                        at['type'] === 'doc' &&
                                        at['type'] != 'time' &&
                                        at['type'] != 'itime' &&
                                        at['type'] !== 'location' &&
                                        at['type'] !== 'boolean' &&
                                        at['type'] !== 'email' &&
                                        at['type'] !== 'json'
                                      "
                                    >
                                      <a
                                        href="{{ getAppDoc(e[at['code']]) }}"
                                        target="_blank"
                                        class="d-inline-block"
                                      >
                                        <img
                                          src="{{
                                            getAppDocThumbnail(e[at['code']])
                                          }}"
                                          class="img-thumbnail rounded-3"
                                          width="60"
                                          alt="Document preview"
                                        />
                                             </a>
                                        </span>
                                    

                                         <span *ngIf="at['type'] === 'email'">
                                         <a href="mailto:{{ e[at['code']] }}" target="_blank">
                                          {{ e[at['code']]}} </a>
                                          </span>

                                         <textarea *ngIf="at['type'] === 'textarea'"
                                           class="form-control form-control-sm fixed-size-textarea"
                                           name="tags"
                                            id="tagsArea"
                                            readonly>{{ e[at['code']] }}</textarea> 

                                      <span *ngIf="at['type'] === 'boolean'">
                                          {{ e[at['code']] == 1 ? 'true' : e[at['code']] == 0 ? 'false' : '' }} 
                                      </span>

                                        <span *ngIf="at['type'] === 'time'">
                                    {{at["depAttribute"]? getString1(e[at["depAttribute"]], at["type"],at['timeFormat']) : getString1(e[at["code"]], at["type"],at['timeFormat'])}}
                                    </span>

                                      <span *ngIf="at['type'] === 'location'">
            <ng-container *ngIf="getLocationObject(at['depAttribute'] ? e[at['depAttribute']] : e[at['code']]) as loc">
              <a [href]="'https://www.google.com/maps?q=' + loc.lat + ',' + loc.lng"
                   target="_blank"   style="text-decoration: none;">{{ loc.lat }},{{ loc.lng }}    </a>
            </ng-container>
           </span>
                                   </ng-container>
                              </td>
                              <td class="align-middle">
                                   <div class="btn-group" *ngIf="form.data.readOnly == 'true'">
                                        <button class="btn btn-sm btn-outline-primary" title="View" type="button"
                                             data-bs-toggle="modal"
                                             [attr.data-bs-target]="'#addChildModel' + form.data['id']">
                                             <i class="bi bi-eye p-0"></i> View
                                        </button>
                                   </div>
                                   <div class="btn-group me-2" *ngIf="form.data.readOnly != 'true'">
                                        <button class="btn btn-sm btn-outline-primary" title="Edit" type="button"
                                             data-bs-toggle="modal"
                                             [attr.data-bs-target]="'#addChildModel' + form.data['id']"
                                             (click)="getUiformData(e.id)">
                                             <i class="fa fa-edit fs-6 p-0"></i>
                                        </button>
                                   </div>
                                   <div class="btn-group" *ngIf="form.data.readOnly != 'true'">
                                        <button class="btn btn-sm btn-outline-danger" title="Delete" type="button"
                                             (click)="deleteUseCaseData(e.id)">
                                             <i class="fa fa-trash fs-6 p-0"></i>
                                        </button>
                                   </div>
                              </td>
                         </tr>
                    </tbody>
               </table>
          </div>
     </div>
</div>

<!--Add/Edit Modal -->
<div class="modal fade" [id]="'addChildModel' + form.data['id']" data-bs-backdrop="static" data-bs-keyboard="false"
     tabindex="-1" [attr.aria-labelledby]="'addChildModelLabel' + form.data['id']" aria-hidden="true">
     <div class="modal-dialog modal-dialog-centered modal-xl modal-lg">
          <div class="modal-content">
               <div class="modal-header">
                    <h1 class="modal-title fs-5" [id]="'addChildModelLabel' + form.data['id']">
                         {{form.data['title']}} Entry Form
                    </h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
               </div>
               <div class="modal-body overflow-auto">

                    <a *ngIf="form.data?.buttons?.['new']" class="btn btn-outline-secondary btn-sm radius-30 mb-2"
                         title="Add New" (click)="fieldButtonSubmit('new')">
                         <i class="fa fa-plus"></i> {{'UI_FORM.CHILD.FORM_BUTTON.NEW' | translate}}
                    </a>

                    <p *ngIf="entryform['error'] == false && entryform['message']">
                         <app-ncs-alert [message]="entryform['message']" type="success" showAlert="true" />
                    </p>
                    <p *ngIf="entryform['error'] == true && entryform['message']">
                         <app-ncs-alert [message]="entryform['message']" type="danger" showAlert="true" />
                         <app-ncs-alert [message]="entryform['inputerror']" type="danger" showAlert="true" />

                    </p>

                    <ng-container *ngFor="let uni of usecaseSchema.unique">
                         <app-ncs-alert *ngIf="isArray(uni) && getInputError(uni.join('_')) !== ''"
                              [message]="getInputError(uni.join('_'))" showAlert="true" type="danger" />
                    </ng-container>

                    <ng-container *ngFor="let group of form.data['groupLabels']; let i = index">

                         <ng-container *ngIf="getGroupsField(group.label).length > 0">
                              <fieldset class="border border-secondary rounded p-3 mb-2">
                                   <legend class="float-none w-auto px-2 text-secondary fs-6">
                                        {{ group.label }}
                                   </legend>

                                   <div *ngIf="form.data['id'] > 0" class="row">

                                        <ng-container *ngFor="let field of getGroupsField(group.label); let i = index">

                                             <ng-container *ngIf="getAttributeById(field.id) as e">

                                                  <ng-container
                                                       *ngIf="e['type'] == 'textarea' && evaluateCondition(field)">

                                                       <div class="col-{{getDefaultColums(form.data.columns, field)}} ">
                                                            <label for="title" class="form-label"
                                                                 *ngIf="e['type'] !== 'file'  && e['type'] !== 'doc'">
                                                                 {{ getFilterLable(e.label) }}
                                                                 <span *ngIf="e['required'] == 1">*</span>
                                                                 <span ncsTooltip [title]="getDescription(e)">
                                                                      <i
                                                                           class="bi bi-info-circle fs-6 ms-2 text-secondary"></i>
                                                                 </span>
                                                            </label>

                                                            <div class="d-flex align-items-center mb-2">
                                                                 <textarea class="form-control" [rows]="field['rows']"
                                                                      cols="{{ field['cols'] }}" class="form-control"
                                                                      [(ngModel)]="entryform.data[e.code]"
                                                                      name="{{ e.code }}"
                                                                      placeholder="{{ getFilterLable(e.label) }}">
                                                                 </textarea>
                                                            </div>
                                                       </div>
                                                  </ng-container>

                                                  <ng-container
                                                       *ngIf="e['type'] !== 'textarea' && evaluateCondition(field)">

                                                       <div class="col-{{getColums(form.data.columns, field)}}">
                                                            <label for="title" class="form-label"
                                                                 *ngIf="e['type'] !== 'file' && e['type'] !== 'doc'">
                                                                 {{ getFilterLable(e.label) }}
                                                                 <span *ngIf="e['required'] == 1">*</span>
                                                                 <span ncsTooltip [title]="getDescription(e)">
                                                                      <i
                                                                           class="bi bi-info-circle fs-6 ms-2 text-secondary"></i>
                                                                 </span>
                                                            </label>

                                                            <label for="title" class="form-label"
                                                                 *ngIf="e['type'] === 'file' && entryform.data['id'] > 0">
                                                                 {{ getFilterLable(e.label) }}
                                                                 <span *ngIf="e['required'] == 1">*</span>
                                                                 <span ncsTooltip [title]="getDescription(e)">
                                                                      <i
                                                                           class="bi bi-info-circle fs-6 ms-2 text-secondary">
                                                                      </i>
                                                                 </span>
                                                            </label>

                                                            <label for="title" class="form-label"
                                                                 *ngIf="e['type'] === 'doc' && entryform.data['id'] > 0">
                                                                 {{ getFilterLable(e.label) }}
                                                                 <span *ngIf="e['required'] == 1">*</span>
                                                                 <span ncsTooltip [title]="getDescription(e)">
                                                                      <i
                                                                           class="bi bi-info-circle fs-6 ms-2 text-secondary">
                                                                      </i>
                                                                 </span>
                                                            </label>

                                                            <div *ngIf="e['refKey'] != 1 && e['type'] !== 'list' && e['type'] !== 'file' && e['type'] !== 'map'  && e['type'] !== 'doc' && e['type'] !== 'location'"
                                                                 class="mb-2">
                                                                 <div class="d-flex align-items-center"
                                                                      *ngIf="evaluateCondition(field)">
                                                                      <input required="{{ e['required'] == 1 }}"
                                                                           [type]="getInputType(e.type)"
                                                                           [(ngModel)]="entryform.data[e.code]"
                                                                           class="form-control form-control-sm"
                                                                           id="{{ e.code }}" name="{{ e.code }}"
                                                                           (change)="checkRuleExecute(e.code); onDateChange($event, e.code,getInputType(e.type))"
                                                                           (click)="e.type === 'date' ? getDateMin(e.minDate, e.maxDate, getInputType(e.type), e?.futureDate, e?.pastDate, e?.pastDateLimit, e?.futureDateLimit) : null"
                                                                           [min]="e.type === 'date' ? minDate : null"
                                                                           [max]="e.type === 'date' ? maxDate : null"
                                                                           placeholder="{{ getFilterLable(e.label) }}"
                                                                           (input)="restrictDecimalPlaces($event, e, e?.placeValue)" />
                                                                 </div>
                                                            </div>

                                                            <!-- Preload DropDown List  -->
                                                            <div *ngIf="e['refKey'] == 1 && e['type'] !== 'location'" class="mb-2">
                                                                 <div class="d-flex align-items-center">
                                                                      <select required="{{ e['required'] == 1 }}"
                                                                           [(ngModel)]="entryform.data[e.code]"
                                                                           [ngClass]="{'placeholder-grey': entryform.data[e.code] === undefined || entryform.data[e.code] === 'undefined'}"
                                                                           (change)="onChange(e, $event);checkRuleExecute(e.code)"
                                                                           class="form-select form-select-sm"
                                                                           id="{{ e.code }}" name="{{ e.code }}">
                                                                           <option [value]="undefined">
                                                                                --Select-- {{ e.label }}
                                                                           </option>
                                                                           <option
                                                                                *ngFor="let c of form.preload?.[e['primaryUsecase']] || [] "
                                                                                value="{{ c['id'] }}">
                                                                                {{ c["_val"] }}
                                                                           </option>
                                                                      </select>
                                                                 </div>
                                                            </div>

                                                            <!-- DropDown List  -->
                                                            <div *ngIf="e['type'] === 'list' && e['type'] !== 'location'" class="mb-2">
                                                                 <div class="d-flex align-items-center">
                                                                      <select required="{{ e['required'] == 1 }}"
                                                                           [(ngModel)]="entryform.data[e.code]"
                                                                           [ngClass]="{'placeholder-grey': entryform.data[e.code] === undefined || entryform.data[e.code] === 'undefined'}"
                                                                           (change)="onChange(e, $event); checkRuleExecute(e.code)"
                                                                           class="form-select form-select-sm"
                                                                           id="{{ e.code }}" name="{{ e.code }}">
                                                                           <option [value]="undefined">
                                                                                --Select-- {{ e.code }}
                                                                           </option>
                                                                           <option *ngFor="let c of e['values']"
                                                                                value="{{ c }}">
                                                                                {{ c }}
                                                                           </option>
                                                                      </select>
                                                                 </div>
                                                            </div>

                                                            <!-- Image File Input (Dynamic) -->
                                                            <div *ngIf="e['type'] === 'file' && e['type'] !== 'location' && entryform.data['id'] > 0"
                                                                 class="mb-2">
                                                                 <div class="d-flex align-items-center">
                                                                      <input class="form-control"
                                                                           id="entryform.data[e.code]" #file type="file"
                                                                           accept="image/*"
                                                                           name="entryform.data[e.code]"
                                                                           (click)="onFileChooseClicked(file, e.code)"
                                                                           (change)="file.files && onImageFileChanged($event, e.code, entryform.data[e.code])" />
                                                                 </div>

                                                                 <!-- Show error only for the specific field -->
                                                                 <div *ngIf="fileErrors[e.code]" class="text-danger">
                                                                      Invalid file type. Please upload only JPEG, JPG,
                                                                      PNG, or GIF files.
                                                                 </div>
                                                                 <div *ngIf="imageSizes[e.code]" class="text-danger">
                                                                      File size is greater than 1 MB.
                                                                 </div>
                                                            </div>

                                                            <!-- Image Preview -->
                                                            <div class="mb-4"
                                                                 *ngIf="e['type'] === 'file' && e['type'] !== 'location' && entryform.data['id'] > 0">
                                                                 <div
                                                                      *ngIf="!fileErrors[e.code] && !imageSizes[e.code]">
                                                                      <img [src]="imagePreviews[e.code] ? imagePreviews[e.code] : getDoc(entryform.data[e.code])"
                                                                           alt="Image Preview" class="img-thumbnail"
                                                                           style="max-width: 200px; max-height: 200px" />
                                                                 </div>
                                                            </div>

                                                            <!-- Doc File  -->
                                                            <div *ngIf="e['type'] === 'doc' && e['type'] !== 'location' && e['type'] !== 'location' && entryform.data['id'] > 0"
                                                                 class="mb-2">
                                                                 <div class="d-flex align-items-center">
                                                                      <input class="form-control"
                                                                           id="entryform.data[e.code]" #filedoc
                                                                           type="file" name="entryform.data[e.code]"
                                                                           (change)="filedoc.files && onFileChanged($event,e.code,entryform.data[e.code])" />
                                                                 </div>
                                                            </div>

                                                            <!-- Doc File Image Preview -->
                                                            <div class="mb-4"
                                                                 *ngIf="e['type'] === 'doc' && e['type'] !== 'location' && entryform.data['id'] > 0">
                                                                 <img [src]="imagePreview == null ? getDocThumbnail(entryform.data[e.code]): imagePreview"
                                                                      alt="Image Preview" class="img-thumbnail"
                                                                      style="max-width: 200px; max-height: 200px" />
                                                            </div>


                                                            <div
                                  *ngIf="e['type'] === 'location'"
                                  class="mb-3 d-flex align-items-center flex-wrap"
                                >
                                  <div
                                    class="d-flex align-items-center flex-wrap"
                                  >
                                    <!-- Latitude & Longitude Inputs -->
                                    <ng-container
                                      *ngIf="
                                        entryform.data[e.code]?.lat != null &&
                                          entryform.data[e.code]?.lng != null;
                                        else noLocation
                                      "
                                      class="d-flex align-items-center flex-wrap"
                                    >
                                      <mat-form-field
                                        appearance="outline"
                                        class="me-2 mb-3"
                                        subscriptSizing="dynamic"
                                      >
                                        <mat-label>Latitude</mat-label>
                                        <input
                                          matInput
                                          type="number"
                                          readonly
                                          [(ngModel)]="
                                            entryform.data[e.code].lat
                                          "
                                          [name]="e.code + '_lat'"
                                        />
                                      </mat-form-field>

                                      <mat-form-field
                                        appearance="outline"
                                        class="me-2 mb-3"
                                        subscriptSizing="dynamic"
                                      >
                                        <mat-label>Longitude</mat-label>
                                        <input
                                          matInput
                                          type="number"
                                          readonly
                                          [(ngModel)]="
                                            entryform.data[e.code].lng
                                          "
                                          [name]="e.code + '_lng'"
                                        />
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-template #noLocation>
                                      <mat-form-field
                                        appearance="outline"
                                        class="me-2 mb-3"
                                        subscriptSizing="dynamic"
                                      >
                                        <mat-label>Latitude</mat-label>
                                        <input
                                          matInput
                                          readonly
                                          value="No location set"
                                          [name]="e.code + '_lat_placeholder'"
                                        />
                                      </mat-form-field>

                                      <mat-form-field
                                        appearance="outline"
                                        class="me-2 mb-3"
                                        subscriptSizing="dynamic"
                                      >
                                        <mat-label>Longitude</mat-label>
                                        <input
                                          matInput
                                          readonly
                                          value="No location set"
                                          [name]="e.code + '_lng_placeholder'"
                                        />
                                      </mat-form-field>
                                    </ng-template>

                                    <!-- Action Buttons -->
                                    <button
                                      mat-stroked-button
                                      type="button"
                                      color="warn"
                                      class="icon-width me-1 mb-3"
                                      [title]="'Set current location'"
                                      (click)="setCurrentLocation(e.code)"
                                    >
                                      <mat-icon class="icon-compact"
                                        >location_on</mat-icon
                                      >
                                    </button>

                                    <button
                                      mat-stroked-button
                                      type="button"
                                      color="primary"
                                      class="icon-width me-1 mb-3"
                                      [title]="'View on map'"
                                      (click)="viewOnMap(e.code)"
                                    >
                                      <mat-icon class="icon-compact"
                                        >map</mat-icon
                                      >
                                    </button>

                                    <button
                                      mat-stroked-button
                                      type="button"
                                      color="warn"
                                      class="icon-width mb-3"
                                      [title]="'Clear location'"
                                      (click)="clearLocation(e.code)"
                                    >
                                      <i
                                        class="fa fa-eraser icon-compact d-inline-block"
                                      ></i>
                                    </button>
                                  </div>
                                </div>

                                                            <!-- Static DropDown List  -->
                                                            <div *ngIf="e['type'] === 'map' && e['type'] !== 'location'" class="mb-2">
                                                                 <div class="d-flex align-items-center">
                                                                      <select required="{{ e['required'] == 1 }}"
                                                                           [(ngModel)]="entryform.data[e.code]"
                                                                           [ngClass]="{'placeholder-grey': entryform.data[e.code] === undefined || entryform.data[e.code] === 'undefined'}"
                                                                           (change)="onChange(e, $event); checkRuleExecute(e.code)"
                                                                           class="form-select form-select-sm"
                                                                           id="{{ e.code }}" name="{{ e.code }}">
                                                                           <option [value]="undefined">
                                                                                --Select-- {{ e.code }}
                                                                           </option>
                                                                           <option *ngFor="let c of e['values']"
                                                                                value="{{ c.key }}">
                                                                                {{ c.value }}
                                                                           </option>
                                                                      </select>
                                                                      <span ncsTooltip [title]="getDescription(e)">
                                                                           <i
                                                                                class="bi bi-info-circle fs-6 ms-2 text-secondary"></i>
                                                                      </span>
                                                                 </div>
                                                            </div>

                                                            <div class="form-text text-danger">
                                                                 {{ getInputError(e.code) }}
                                                            </div>
                                                       </div>
                                                  </ng-container>

                                             </ng-container>

                                        </ng-container>

                                   </div>
                              </fieldset>
                         </ng-container>

                    </ng-container>

                    <div *ngIf="form.data['id'] > 0" class="row">
                         <ng-container *ngFor="let field of getFieldNotIngroup(); let i = index">
                              <ng-container *ngIf="getAttributeById(field.id) as e">
                                   
                                   <ng-container *ngIf="e['type'] == 'textarea' && evaluateCondition(field)">
                                        <div class="col-{{getDefaultColums(form.data.columns, field)}} ">
                                             <label for="title" class="form-label"
                                                  *ngIf="e['type'] !== 'file' && e['type'] !== 'doc'">
                                                  {{ getFilterLable(e.label) }}
                                                  <span *ngIf="e['required'] == 1">*</span>
                                                  <span ncsTooltip [title]="getDescription(e)">
                                                       <i class="bi bi-info-circle fs-6 ms-2 text-secondary"></i>
                                                  </span>
                                             </label>

                                             <div class="d-flex align-items-center mb-2">
                                                  <textarea class="form-control" [rows]="field['rows']"
                                                       cols="{{ field['cols'] }}" class="form-control"
                                                       [(ngModel)]="entryform.data[e.code]" name="{{ e.code }}"
                                                       placeholder="{{ getFilterLable(e.label) }}">
                                                  </textarea>
                                             </div>
                                        </div>
                                   </ng-container>

                                   <ng-container *ngIf="e['type'] !== 'textarea' && evaluateCondition(field)">
                                        <div class="col-{{ getColums(form.data.columns, field) }}">
                                             <label for="title" class="form-label"
                                                  *ngIf="e['type'] !== 'file' && e['type'] !== 'doc'">
                                                  {{ getFilterLable(e.label) }}
                                                  <span *ngIf="e['required'] == 1">*</span>
                                                  <span ncsTooltip [title]="getDescription(e)">
                                                       <i class="bi bi-info-circle fs-6 ms-2 text-secondary"></i>
                                                  </span>
                                             </label>

                                             <label for="title" class="form-label"
                                                  *ngIf="e['type'] === 'file' && entryform.data['id'] > 0">{{
                                                  getFilterLable(e.label) }}
                                                  <span *ngIf="e['required'] == 1">*</span>
                                                  <span ncsTooltip [title]="getDescription(e)">
                                                       <i class="bi bi-info-circle fs-6 ms-2 text-secondary"></i>
                                                  </span>
                                             </label>

                                             <label for="title" class="form-label"
                                                  *ngIf="e['type'] === 'doc' && entryform.data['id'] > 0">{{
                                                  getFilterLable(e.label) }}
                                                  <span *ngIf="e['required'] == 1">*</span>
                                                  <span ncsTooltip [title]="getDescription(e)">
                                                       <i class="bi bi-info-circle fs-6 ms-2 text-secondary"></i>
                                                  </span>
                                             </label>

                                             <div *ngIf="e['refKey'] != 1 && e['type'] !== 'list' && e['type'] !== 'file' && e['type'] !== 'map' && e['type'] !== 'doc' && e['type'] !== 'location' && e['type'] !== 'boolean' && e['type'] !== 'password' && e['type'] !== 'dateandtime' &&
                                    e['type'] !== 'idate' &&
                                    e['type'] !== 'date' &&
                                    e['type'] !== 'time' &&
                                    e['type'] !== 'itime'"
                                                  class="mb-2">
                                                  <div class="d-flex align-items-center"
                                                       *ngIf="evaluateCondition(field)">
                                                       <input required="{{ e['required'] == 1 }}"
                                                            [type]="getInputType(e.type)"
                                                            [(ngModel)]="entryform.data[e.code]"
                                                            class="form-control form-control-sm" id="{{ e.code }}"
                                                            name="{{ e.code }}"
                                                            (change)="checkRuleExecute(e.code); onDateChange($event, e.code,getInputType(e.type))"
                                                            (click)="e.type === 'date' ? getDateMin(e.minDate, e.maxDate, getInputType(e.type), e?.futureDate, e?.pastDate, e?.pastDateLimit, e?.futureDateLimit) : null"
                                                            [min]="e.type === 'date' ? minDate : null"
                                                            [max]="e.type === 'date' ? maxDate : null"
                                                            placeholder="{{ getFilterLable(e.label) }}"
                                                            (input)="restrictDecimalPlaces($event, e, e?.placeValue)" />
                                                  </div>
                                             </div>


                                             <div *ngIf="e['type'] == 'date'" class="mb-2">
                                  <div *ngIf="evaluateCondition(field)">
                                    <mat-form-field
                                      appearance="outline"
                                      class="w-100"
                                      subscriptSizing="dynamic"
                                    >
                                      <input
                                        #dateInput
                                        matInput
                                        [type]="getInputType(e.type)"
                                        [(ngModel)]="entryform.data[e.code]"
                                        id="{{ e.code }}"
                                        name="{{ e.code }}"
                                        [required]="e['required'] == 1"
                                        [readonly]="
                                          e['readOnly'] ||
                                          (e.allowChangeAfterInitial == 1 &&
                                            entryform.data['id'] > 0)
                                        "
                                        (change)="
                                          checkRuleExecute(e.code);
                                          onDateChange(
                                            $event,
                                            e.code,
                                            getInputType(e.type)
                                          );
                                          enforceMaxDate($event, e.code, e.type)
                                        "
                                        (input)="
                                          restrictDecimalPlaces(
                                            $event,
                                            e,
                                            e?.placeValue
                                          )
                                        "
                                        [min]="
                                          e.type === 'date' ? e.minDate : null
                                        "
                                        [max]="
                                          e.type === 'date' ? e.maxDate : null
                                        "
                                      />

                                      <button
                                        mat-icon-button
                                        matSuffix
                                        class="icon-pd-none"
                                        type="button"
                                        (click)="dateInput.showPicker()"
                                      >
                                        <mat-icon
                                          class="icon-compact text-secondary"
                                          >calendar_today</mat-icon
                                        >
                                      </button>
                                    </mat-form-field>
                                  </div>
                                </div>

                                <div *ngIf="e['type'] == 'time'" class="mb-2">
                                  <div *ngIf="evaluateCondition(field)">
                                    <mat-form-field
                                      appearance="outline"
                                      class="w-100"
                                      subscriptSizing="dynamic"
                                    >
                                      <input
                                        #dateInput
                                        matInput
                                        [type]="getInputType(e.type)"
                                        [(ngModel)]="entryform.data[e.code]"
                                        id="{{ e.code }}"
                                        name="{{ e.code }}"
                                        [required]="e['required'] == 1"
                                        [readonly]="
                                          e['readOnly'] ||
                                          (e.allowChangeAfterInitial == 1 &&
                                            entryform.data['id'] > 0)
                                        "
                                        (change)="
                                          checkRuleExecute(e.code);
                                          onDateChange(
                                            $event,
                                            e.code,
                                            getInputType(e.type)
                                          );
                                          enforceMaxDate($event, e.code, e.type)
                                        "
                                        (input)="
                                          restrictDecimalPlaces(
                                            $event,
                                            e,
                                            e?.placeValue
                                          )
                                        "
                                      />

                                      <button
                                        mat-icon-button
                                        matSuffix
                                        class="icon-pd-none"
                                        type="button"
                                        (click)="dateInput.showPicker()"
                                      >
                                        <mat-icon
                                          class="icon-compact text-secondary"
                                          >schedule</mat-icon
                                        >
                                      </button>
                                    </mat-form-field>
                                  </div>
                                </div>

                                <div *ngIf="e['type'] == 'itime'" class="mb-2">
                                  <div *ngIf="evaluateCondition(field)">
                                    <mat-form-field
                                      appearance="outline"
                                      class="w-100"
                                      subscriptSizing="dynamic"
                                    >
                                      <input
                                        #dateInput
                                        matInput
                                        [type]="getInputType(e.type)"
                                        [(ngModel)]="entryform.data[e.code]"
                                        id="{{ e.code }}"
                                        name="{{ e.code }}"
                                        [required]="e['required'] == 1"
                                        [readonly]="
                                          e['readOnly'] ||
                                          (e.allowChangeAfterInitial == 1 &&
                                            entryform.data['id'] > 0)
                                        "
                                        (change)="
                                          checkRuleExecute(e.code);
                                          onDateChange(
                                            $event,
                                            e.code,
                                            getInputType(e.type)
                                          );
                                          enforceMaxDate($event, e.code, e.type)
                                        "
                                        (input)="
                                          restrictDecimalPlaces(
                                            $event,
                                            e,
                                            e?.placeValue
                                          )
                                        "
                                      />

                                      <button
                                        mat-icon-button
                                        matSuffix
                                        class="icon-pd-none"
                                        type="button"
                                        (click)="dateInput.showPicker()"
                                      >
                                        <mat-icon
                                          class="icon-compact text-secondary"
                                          >schedule</mat-icon
                                        >
                                      </button>
                                    </mat-form-field>
                                  </div>
                                </div>

                                <div
                                  *ngIf="e['type'] === 'dateandtime'"
                                  class="mb-2"
                                >
                                  <div *ngIf="evaluateCondition(field)">
                                    <mat-form-field
                                      appearance="outline"
                                      class="w-100"
                                    >
                                      <input
                                        #dateInput
                                        matInput
                                        type="datetime-local"
                                        [(ngModel)]="entryform.data[e.code]"
                                        id="{{ e.code }}"
                                        name="{{ e.code }}"
                                        [required]="e.required"
                                        [readonly]="
                                          e['readOnly'] ||
                                          (e.allowChangeAfterInitial == 1 &&
                                            entryform.data['id'] > 0)
                                        "
                                      />

                                      <button
                                        mat-icon-button
                                        matSuffix
                                        type="button"
                                        class="icon-pd-none"
                                        (click)="dateInput.showPicker()"
                                      >
                                        <mat-icon
                                          class="icon-compact text-secondary"
                                          >event</mat-icon
                                        >
                                      </button>
                                    </mat-form-field>
                                  </div>
                                </div>

                                <div *ngIf="e['type'] == 'idate'" class="mb-2">
                                  <div *ngIf="evaluateCondition(field)">
                                    <mat-form-field
                                      appearance="outline"
                                      class="w-100"
                                      subscriptSizing="dynamic"
                                    >
                                      <input
                                        #dateInput
                                        matInput
                                        [type]="getInputType(e.type)"
                                        [(ngModel)]="entryform.data[e.code]"
                                        id="{{ e.code }}"
                                        name="{{ e.code }}"
                                        [required]="e['required'] == 1"
                                        [readonly]="
                                          e['readOnly'] ||
                                          (e.allowChangeAfterInitial == 1 &&
                                            entryform.data['id'] > 0)
                                        "
                                        (change)="
                                          checkRuleExecute(e.code);
                                          onDateChange(
                                            $event,
                                            e.code,
                                            getInputType(e.type)
                                          );
                                          enforceMaxDate($event, e.code, e.type)
                                        "
                                        (input)="
                                          restrictDecimalPlaces(
                                            $event,
                                            e,
                                            e?.placeValue
                                          )
                                        "
                                        [min]="
                                          e.type === 'idate'
                                            ? convertIntoLocalDate(e.minDate)
                                            : null
                                        "
                                        [max]="
                                          e.type === 'idate'
                                            ? convertIntoLocalDate(e.maxDate)
                                            : null
                                        "
                                      />

                                      <!-- Right side calendar icon -->
                                      <button
                                        mat-icon-button
                                        matSuffix
                                        class="icon-pd-none"
                                        type="button"
                                        (click)="dateInput.showPicker()"
                                      >
                                        <mat-icon
                                          class="icon-compact text-secondary"
                                          >calendar_today</mat-icon
                                        >
                                      </button>
                                    </mat-form-field>
                                  </div>
                                </div>

                                             <div
                                  *ngIf="e['type'] === 'location'"
                                  class="mb-3 d-flex align-items-center flex-wrap"
                                >
                                  <div
                                    class="d-flex align-items-center flex-wrap"
                                  >
                                    <!-- Latitude & Longitude Inputs -->
                                    <ng-container
                                      *ngIf="
                                        entryform.data[e.code]?.lat != null &&
                                          entryform.data[e.code]?.lng != null;
                                        else noLocation
                                      "
                                      class="d-flex align-items-center flex-wrap"
                                    >
                                      <mat-form-field
                                        appearance="outline"
                                        class="me-2 mb-3"
                                        subscriptSizing="dynamic"
                                      >
                                        <mat-label>Latitude</mat-label>
                                        <input
                                          matInput
                                          type="number"
                                          readonly
                                          [(ngModel)]="
                                            entryform.data[e.code].lat
                                          "
                                          [name]="e.code + '_lat'"
                                        />
                                      </mat-form-field>

                                      <mat-form-field
                                        appearance="outline"
                                        class="me-2 mb-3"
                                        subscriptSizing="dynamic"
                                      >
                                        <mat-label>Longitude</mat-label>
                                        <input
                                          matInput
                                          type="number"
                                          readonly
                                          [(ngModel)]="
                                            entryform.data[e.code].lng
                                          "
                                          [name]="e.code + '_lng'"
                                        />
                                      </mat-form-field>
                                    </ng-container>

                                    <ng-template #noLocation>
                                      <mat-form-field
                                        appearance="outline"
                                        class="me-2 mb-3"
                                        subscriptSizing="dynamic"
                                      >
                                        <mat-label>Latitude</mat-label>
                                        <input
                                          matInput
                                          readonly
                                          value="No location set"
                                          [name]="e.code + '_lat_placeholder'"
                                        />
                                      </mat-form-field>

                                      <mat-form-field
                                        appearance="outline"
                                        class="me-2 mb-3"
                                        subscriptSizing="dynamic"
                                      >
                                        <mat-label>Longitude</mat-label>
                                        <input
                                          matInput
                                          readonly
                                          value="No location set"
                                          [name]="e.code + '_lng_placeholder'"
                                        />
                                      </mat-form-field>
                                    </ng-template>

                                    <!-- Action Buttons -->
                                    <button
                                      mat-stroked-button
                                      type="button"
                                      color="warn"
                                      class="icon-width me-1 mb-3"
                                      [title]="'Set current location'"
                                      (click)="setCurrentLocation(e.code)"
                                    >
                                      <mat-icon class="icon-compact"
                                        >location_on</mat-icon
                                      >
                                    </button>

                                    <button
                                      mat-stroked-button
                                      type="button"
                                      color="primary"
                                      class="icon-width me-1 mb-3"
                                      [title]="'View on map'"
                                      (click)="viewOnMap(e.code)"
                                    >
                                      <mat-icon class="icon-compact"
                                        >map</mat-icon
                                      >
                                    </button>

                                    <button
                                      mat-stroked-button
                                      type="button"
                                      color="warn"
                                      class="icon-width mb-3"
                                      [title]="'Clear location'"
                                      (click)="clearLocation(e.code)"
                                    >
                                      <i
                                        class="fa fa-eraser icon-compact d-inline-block"
                                      ></i>
                                    </button>
                                  </div>
                                </div>

                                 <div
                                  *ngIf="e['type'] === 'password'"
                                  class="mb-2"
                                >
                                  <div
                                    class="d-flex align-items-center"
                                    *ngIf="evaluateCondition(field)"
                                  >
                                    <mat-form-field
                                      appearance="outline"
                                      class="w-100"
                                      subscriptSizing="dynamic"
                                    >
                                      <input
                                        matInput
                                        [id]="e.code"
                                        [name]="e.code"
                                        [type]="
                                          showPassword ? 'text' : 'password'
                                        "
                                        [(ngModel)]="entryform.data[e.code]"
                                        [placeholder]="
                                          getFilterLable(e.label) ||
                                          'Enter password'
                                        "
                                      />
                                      <button
                                        matSuffix
                                        mat-icon-button
                                        type="button"
                                        class="icon-pd-none"
                                        (click)="togglePasswordVisibility()"
                                        [attr.aria-label]="
                                          'Toggle password visibility'
                                        "
                                        [attr.aria-pressed]="showPassword"
                                      >
                                        <mat-icon
                                          class="icon-compact text-secondary"
                                          >{{
                                            showPassword
                                              ? "visibility"
                                              : "visibility_off"
                                          }}</mat-icon
                                        >
                                      </button>
                                    </mat-form-field>
                                  </div>
                                </div>


                                <div
                                  *ngIf="e['type'] === 'boolean'"
                                  class="mb-2"
                                >
                                  <div
                                    class="d-flex align-items-center"
                                    *ngIf="evaluateCondition(field)"
                                  >
                                    <mat-form-field
                                      appearance="outline"
                                      class="w-100"
                                      subscriptSizing="dynamic"
                                    >
                                      <mat-select
                                        [(ngModel)]="entryform.data[e.code]"
                                        [id]="e.code"
                                        [name]="e.code"
                                        placeholder=" --Select--"
                                      >
                                        <mat-option
                                          [value]="undefined"
                                          disabled
                                        >
                                          --Select--
                                        </mat-option>
                                        <mat-option [value]="1"
                                          >True</mat-option
                                        >
                                        <mat-option [value]="0"
                                          >False</mat-option
                                        >
                                      </mat-select>
                                    </mat-form-field>
                                  </div>
                                </div>


                                             <!-- Preload DropDown List  -->
                                             <div *ngIf="e['refKey'] == 1" class="mb-2">
                                                  <div class="d-flex align-items-center">
                                                       <select required="{{ e['required'] == 1 }}"
                                                            [(ngModel)]="entryform.data[e.code]"
                                                            [disabled]="e.code === parentKey"
                                                            [ngClass]="{'placeholder-grey': entryform.data[e.code] === undefined || entryform.data[e.code] === 'undefined'}"
                                                            (change)="onChange(e, $event); checkRuleExecute(e.code)"
                                                            class="form-select form-select-sm" id="{{ e.code }}"
                                                            name="{{ e.code }}">
                                                            <option [value]="undefined">
                                                                 --Select-- {{ e.label }}
                                                            </option>
                                                            <option
                                                                 *ngFor="let c of form.preload?.[e['primaryUsecase']] || [] "
                                                                 value="{{ c['id'] }}">
                                                                 {{ c["_val"] }}
                                                            </option>
                                                       </select>
                                                  </div>
                                             </div>

                                             <!-- DropDown List  -->
                                             <div
                                  *ngIf="e['type'] === 'list'"
                                  class="mb-2 w-100"
                                >
                                  <div
                                    *ngIf="
                                      e['listType'] === 'none' ||
                                      e['listType'] === '' ||
                                      !e['listType'] ||
                                      e['listType'] === 'checkbox'
                                    "
                                    class="d-flex align-items-center w-100"
                                  >
                                    <!-- MULTIPLE SELECT (CHECKBOXES IN DROPDOWN) -->
                                    <div
                                      *ngIf="e['multipleSelect'] == 1"
                                      class="position-relative w-100"
                                    >
                                      <mat-form-field
                                        appearance="outline"
                                        class="w-100"
                                        subscriptSizing="dynamic"
                                      >
                                        <mat-select
                                          [multiple]="true"
                                          [(ngModel)]="entryform.data[e.code]"
                                          [disabled]="
                                            e['readOnly'] ||
                                            (e.allowChangeAfterInitial == 1 &&
                                              entryform.data['id'] > 0)
                                          "
                                          (selectionChange)="
                                            onCheckboxChange(
                                              e,
                                              $event.value,
                                              $event
                                            )
                                          "
                                          [required]="e['required'] == 1"
                                          [class.disabled-span]="
                                            e['required'] == 1
                                          "
                                          (openedChange)="toggleDropdown(e)"
                                        >
                                          <mat-select-trigger>
                                            <span
                                              class="text-truncate"
                                              [ngClass]="{
                                                'placeholder-grey':
                                                  !getSelectedText(e),
                                              }"
                                            >
                                              {{ getSelectedText(e) || "" }}
                                            </span>
                                          </mat-select-trigger>

                                          <mat-option
                                            *ngFor="let option of e['values']"
                                            [value]="option"
                                            class="p-1"
                                          >
                                            <span [title]="option">
                                              {{
                                                option
                                                  | truncate
                                                    : getTruncateLimit(
                                                        form.data.columns
                                                      )
                                              }}
                                            </span>
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>
                                    </div>

                                    <!-- SINGLE SELECT (DROPDOWN) -->
                                    <mat-form-field
                                      *ngIf="e['multipleSelect'] != 1"
                                      appearance="outline"
                                      class="w-100"
                                      subscriptSizing="dynamic"
                                    >
                                      <mat-select
                                                            [(ngModel)]="entryform.data[e.code]"
                                        [disabled]="
                                          e['readOnly'] ||
                                          (e.allowChangeAfterInitial == 1 &&
                                            entryform.data['id'] > 0)
                                        "
                                        [required]="e['required'] == 1"
                                        (selectionChange)="onChange(e, $event)"
                                        (openedChange)="toggleDropdown(e)"
                                        [class.placeholder-grey]="
                                          entryform.data[e.code] ===
                                            undefined ||
                                          entryform.data[e.code] === 'undefined'
                                        "
                                      >
                                        <mat-option
                                          [disabled]="e['required'] == 1"
                                          [value]="undefined"
                                        >
                                                                 --Select-- {{ e.label }}
                                        </mat-option>
                                        <mat-option
                                          *ngFor="let c of e['values']"
                                          [value]="c"
                                          [title]="c"
                                        >
                                          {{
                                            c
                                              | truncate
                                                : getTruncateLimit(
                                                    form.data.columns
                                                  )
                                          }}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                  </div>

                                  <!-- RADIO LIST TYPE -->
                                  <div
                                    *ngIf="e['listType'] === 'radio'"
                                    class="w-100"
                                  >
                                    <!-- HORIZONTAL RADIO -->
                                    <div
                                      *ngIf="e['showVertical'] === 'horizontal'"
                                      class="d-flex flex-wrap gap-3"
                                    >
                                      <mat-radio-group
                                        [(ngModel)]="entryform.data[e.code]"
                                        [disabled]="
                                          e['readOnly'] ||
                                          (e.allowChangeAfterInitial == 1 &&
                                            entryform.data['id'] > 0)
                                        "
                                        (change)="
                                          onRadioChange(e, $event.value)
                                        "
                                        class="d-flex flex-wrap"
                                      >
                                        <mat-radio-button
                                          *ngFor="let option of e['values']"
                                          [value]="option"
                                          class="me-3"
                                          color="primary"
                                        >
                                          {{ option }}
                                        </mat-radio-button>
                                      </mat-radio-group>
                                    </div>

                                    <!-- VERTICAL RADIO -->
                                    <div
                                      *ngIf="e['showVertical'] === 'vertical'"
                                      class="d-flex flex-column gap-2"
                                    >
                                      <mat-radio-group
                                        [(ngModel)]="entryform.data[e.code]"
                                        [disabled]="
                                          e['readOnly'] ||
                                          (e.allowChangeAfterInitial == 1 &&
                                            entryform.data['id'] > 0)
                                        "
                                        (change)="
                                          onRadioChange(e, $event.value)
                                        "
                                        class="d-flex flex-column"
                                      >
                                        <mat-radio-button
                                          *ngFor="let option of e['values']"
                                          [value]="option"
                                          class="my-1"
                                          color="primary"
                                        >
                                          {{ option }}
                                        </mat-radio-button>
                                      </mat-radio-group>
                                    </div>
                                                  </div>
                                             </div>

                                             <!-- Image File Input (Dynamic) -->
                                             <div *ngIf="e['type'] === 'file' && entryform.data['id'] > 0" class="mb-2">
                                                  <div class="d-flex align-items-center">
                                                       <input class="form-control" id="entryform.data[e.code]" #file
                                                            type="file" accept="image/*" name="entryform.data[e.code]"
                                                            (click)="onFileChooseClicked(file,e.code)"
                                                            (change)="file.files && onImageFileChanged($event, e.code, entryform.data[e.code])" />
                                                  </div>

                                                  <!-- Show error only for the specific field -->
                                                  <div *ngIf="fileErrors[e.code]" class="text-danger">
                                                       Invalid file type. Please upload only JPEG, JPG, PNG, or GIF
                                                       files.
                                                  </div>
                                                  <div *ngIf="imageSizes[e.code]" class="text-danger">
                                                       File size is greater than 1 MB.
                                                  </div>
                                             </div>

                                             <!-- Image Preview -->
                                             <div class="mb-4" *ngIf="e['type'] === 'file' && entryform.data['id'] > 0">
                                                  <div *ngIf="!fileErrors[e.code] && !imageSizes[e.code]">
                                                       <img [src]="imagePreviews[e.code] ? imagePreviews[e.code] : getDoc(entryform.data[e.code])"
                                                            alt="Image Preview" class="img-thumbnail"
                                                            style="max-width: 200px; max-height: 200px" />
                                                  </div>
                                             </div>


                                             <!-- Doc File  -->
                                             <div *ngIf="e['type'] === 'doc' && entryform.data['id'] > 0" class="mb-2">
                                                  <div class="d-flex align-items-center">
                                                       <input class="form-control" id="entryform.data[e.code]" #filedoc
                                                            type="file" name="entryform.data[e.code]"
                                                            (change)="filedoc.files && onFileChanged($event,e.code,entryform.data[e.code])" />
                                                  </div>
                                             </div>

                                             <!--Image Preview Doc Preview -->
                                             <div class="mb-4" *ngIf="e['type'] === 'doc' && entryform.data['id'] > 0">
                                                  <img [src]="imagePreview == null ? getDocThumbnail(entryform.data[e.code]): imagePreview"
                                                       alt="Image Preview" class="img-thumbnail"
                                                       style="max-width: 200px; max-height: 200px" />
                                             </div>

                                             <!-- Static DropDown List  -->
                                             <div *ngIf="e['type'] === 'map'" class="mb-2">
                                                  <div class="d-flex align-items-center">
                                                       <select required="{{ e['required'] == 1 }}"
                                                            [(ngModel)]="entryform.data[e.code]"
                                                            [ngClass]="{'placeholder-grey': entryform.data[e.code] === undefined || entryform.data[e.code] === 'undefined'}"
                                                            (change)="onChange(e, $event)"
                                                            class="form-select form-select-sm" id="{{ e.code }}"
                                                            name="{{ e.code }}">
                                                            <option [value]="undefined">
                                                                 --Select-- {{ e.code }}
                                                            </option>
                                                            <option *ngFor="let c of e['values']"
                                                                 value="{{ c.key }} - {{ c.value }}">
                                                                 {{ c.key }} - {{ c.value }}
                                                            </option>
                                                       </select>
                                                       <span ncsTooltip [title]="getDescription(e)">
                                                            <i class="bi bi-info-circle fs-6 ms-2 text-secondary"></i>
                                                       </span>
                                                  </div>
                                             </div>

                                             <div class="form-text text-danger">
                                                  {{ getInputError(e.code) }}
                                             </div>
                                        </div>
                                   </ng-container>
                              </ng-container>
                         </ng-container>

                         <div *ngFor="let field of form.data['fields']; let i = index"
                              class="col-{{ getColums(form.data.columns, field) }}  {{getRows(field)}}"></div>
                    </div>

                    <div *ngIf="form.data['id'] == 0">not field for edit</div>

                    <!-- Card Footer with Button Group -->
                    <div class="text-start" *ngIf="form.data['id'] > 0">
                         <div class="btn-group" *ngIf="form.data.readOnly != 'true'">
                              <button *ngFor="let btn of  filterBtns()" type="button"
                                   class="btn btn-sm btn-outline-primary ms-2" (click)="fieldButtonSubmit(btn['name'])">
                                   <i [class]="getButtonIcon(btn['name'])"></i>
                                   {{ getButtonLabel(btn["name"]) | translate}}
                              </button>
                         </div>
                    </div>

               </div>
               <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary btn-sm" data-bs-dismiss="modal">
                         <i class="fa fa-window-close"></i> Close
                    </button>
               </div>
          </div>
     </div>
</div>